<template>
    <v-data-table :headers="headers"
                  :items="items"
                  :loading="progress('getClientServicesByClientId')"
                  hide-default-footer
                  no-data-text="No client services"
                  :items-per-page="-1">
        <template v-slot:item="props">
            <client-service-item :item="props.item">
            </client-service-item>
        </template>
    </v-data-table>
</template>

<script>
    import {mapGetters} from 'vuex'
    import ClientServiceItem from './ClientServiceItem';

    export default {
        name: 'ClientServiceList',
        props: {
            items: Array
        },
        components: {
            ClientServiceItem
        },
        data() {
            return {
                headers: [
                    {
                        text: 'Code',
                        align: 'left',
                        sortable: false,
                        value: 'code',
                        width: '100'
                    },
                    {
                        text: 'Title',
                        align: 'left',
                        sortable: false,
                        value: 'title',
                        width: '500'
                    },
                    {
                        text: 'Price',
                        align: 'left',
                        sortable: false,
                        value: 'price',
                    },
                    {
                        text: 'Actions',
                        align: 'left',
                        sortable: false,
                        width: '140'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters('services', {
                progress: 'progress'
            }),
        },
        methods: {}
    }
</script>

<style scoped>

</style>